import img from "./img/visit-us.png";
import img1 from "./img/icon-1.png";
import img2 from "./img/icon-2.png";
import img3 from "./img/icon-3.png";
import img4 from "./img/icon-4.png";

function Visit() {
  return (
    <>
      <section className=" relative flex items-center justify-center bg-img visit h-[50vh]">
        <h1 className="head text-[4rem] bg-white p-[50px] px-[70px] gold">
          We are serving breakfast fro 10am till 11pm{" "}
        </h1>
        <img className="absolute bottom-0 right-0 h-[200px]" src={img} alt="" />
      </section>
      <section className="p-[100px] flex justify-around">
        <div className="flex flex-col items-center justify-center ">
          <img src={img1} className="" alt="img"></img>
          <h1 className="gold head text-[3rem]">Caramel Syrup</h1>
          <p className="gold w-[70%] text-[1.2rem] text-center">
            Lorem ipsum dolor sit amet, conse ctetu adipi scing elit, sed.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center ">
          <img src={img2} className="" alt="img"></img>
          <h1 className="gold head text-[3rem]">Caramel Syrup</h1>
          <p className="gold w-[70%] text-[1.2rem] text-center">
            Lorem ipsum dolor sit amet, conse ctetu adipi scing elit, sed.
          </p>
        </div>{" "}
        <div className="flex flex-col items-center justify-center ">
          <img src={img3} className="" alt="img"></img>
          <h1 className="gold head text-[3rem]">Caramel Syrup</h1>
          <p className="gold w-[70%] text-[1.2rem] text-center">
            Lorem ipsum dolor sit amet, conse ctetu adipi scing elit, sed.
          </p>
        </div>{" "}
        <div className="flex flex-col items-center justify-center ">
          <img src={img4} className="" alt="img"></img>
          <h1 className="gold head text-[3rem]">Caramel Syrup</h1>
          <p className="gold w-[70%] text-[1.2rem] text-center">
            Lorem ipsum dolor sit amet, conse ctetu adipi scing elit, sed.
          </p>
        </div>
      </section>
    </>
  );
}

export { Visit };
